export const SERVICE_ID = 'omfe-jwv-hpallin-deviceonboarding'

const BASE_PATH = '/HPAllInDeviceOnboarding/'

const ACTIVITY = 'HardwareSetup-v01'

export const ANALYTICS = {
  SCREENS: {
    START: {
      screenName: 'Start',
      activity: ACTIVITY,
      screenPath: BASE_PATH
    },
    COMPLETED: {
      screenName: 'Completed',
      activity: ACTIVITY,
      screenPath: BASE_PATH
    },
    ACTIVATION: {
      screenName: 'Activation',
      activity: ACTIVITY,
      screenPath: BASE_PATH
    },
    ACTIVATION_FAILED: {
      screenName: 'ActivationFailed',
      activity: ACTIVITY,
      screenPath: BASE_PATH
    },
    SUBSCRIPTION_ERROR: {
      screenName: 'SubscriptionError',
      activity: ACTIVITY,
      screenPath: BASE_PATH
    }
  },
  CONTROLS: {
    CONTINUE_BUTTON: 'ContinueButton',
    RETRY: 'RetryButton',
    EXIT_SETUP: 'ExitSetupButton',
    SUPPORT_BUTON: 'SupportButton',
    ENABLE_WEB_SERVICES: 'EnableWebServices',
    SUCCESS: 'Success',
    INELIGIBLE: 'Ineligible'
  },
  MODES: {
    INTERFACE: {
      [true]: 'Ledm',
      [false]: 'Cdm'
    }
  },
  SUPPORT_LINK: 'SupportLink'
}

export { ContentStackContentTypes } from 'src/config/constants'

export const SUBSCRIPTION_STATES = {
  PENDING: 'pending',
  DEACTIVATING: 'deactivating',
  SUSPENDED: 'suspended',
  INACTIVE: 'inactive'
}

export const OOBE_STATUS = {
  CANCEL_WITHIN_TRIAL: 'cancelWithinTrial',
  CANCEL_AFTER_TRIAL: 'cancelAfterTrial',
  WARRANTY: 'warranty'
}

export const ENROLLMENT_OUTPUT = {
  SUCCESS: 'success',
  FAILURE: 'failure'
}
